/**
 * Build Your Box - Final Version (Exclusive Subscription)
 *  - Tiered discount: ₹700+ → 30%, ₹1200+ → 36%
 *  - Tier pills + free blood-test perk + How It Works
 *  - Monthly-first pricing; Mobile: slim sticky bar + review modal
 *  - NEW: Desktop footer uses a one-row stat strip (Monthly · 6 Months · You Save)
 *    with gold savings ribbon + flickering "less than ₹XX/day"
 */

class BuildYourBox {
  constructor() {
    this.section = document.querySelector('.build-your-box-section');
    if (!this.section) return;

    this.sectionId = this.section.dataset.sectionId;
    this.discountPercent = parseInt(this.section.dataset.discount) || 0;

    this.minSubtotal = 70000; // ₹700 in cents (raw MONTHLY MRP)
    this.months = 6;
    this.daysPerMonth = 30;
    this.checkoutMultiplier = this.months;

    this.checkoutBtn = this.section.querySelector('.byb-checkout-btn');
    this.totalPriceEl = this.section.querySelector('[data-total-price]');
    this.savingsEl = this.section.querySelector('[data-savings]');
    this.savingsContainer = this.section.querySelector('.byb-savings');
    this.stickyFooter = this.section.querySelector('.byb-sticky-footer');

    this.sixMonthTotalEl = null;
    this.tierHintEl = null;
    this.monthlyLeadEl = null;
    this.perDayEl = null;
    this.stripEls = null; // NEW: stat strip element refs

    this.reviewModal = null;
    this.modalOpen = false;

    this.selectedProducts = [];
    this.init();
  }

  init() {
    this.ensureSubheadingTiers();
    this.ensureBloodTestPerk();
    this.ensureHowItWorks();
    this.renameMonthlyTotalLabel();
    this.ensureMonthlyLead();
    this.ensureTierHintLine();
    this.ensureSixMonthLine();
    this.ensurePerDayLine();
    this.ensureStatStrip(); // NEW
    this.buildReviewModal();
    this.interceptAddToCart();
    this.bindEvents();
    this.updateUI();
    this.initStickyFooter();
  }

  isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  getSubtotal() {
    return this.selectedProducts.reduce((sum, p) => sum + p.productPrice * p.qty, 0);
  }
  getCount() {
    return this.selectedProducts.reduce((sum, p) => sum + p.qty, 0);
  }
  getQtyForProduct(productId) {
    return this.selectedProducts
      .filter(p => p.productId === productId)
      .reduce((sum, p) => sum + p.qty, 0);
  }

  ensureSubheadingTiers() {
    const p = this.section.querySelector('.byb-subheading-wrapper .byb-subheading')
      || this.section.querySelector('.byb-subheading');
    if (!p || p.querySelector('.byb-tier-pills')) return;
    p.innerHTML =
      '<span class="byb-tier-pills">' +
        '<span class="byb-tier-pill byb-tier-pill--a"><span class="pct">30% OFF</span>at ₹700/month</span>' +
        '<span class="byb-tier-pill byb-tier-pill--b"><span class="pct">36% OFF</span>above ₹1200/month</span>' +
      '</span>';
  }

  ensureHowItWorks() {
    if (this.section.querySelector('.byb-how-it-works')) return;
    const anchor = this.section.querySelector('.byb-blood-perk')
      || this.section.querySelector('.byb-subheading-wrapper');
    if (!anchor) return;

    const steps = [
      { n: '1', t: 'Pick your products', d: 'Choose your favourites below' },
      { n: '2', t: 'Order once', d: 'Receive a box every month for 6 months' },
      { n: '3', t: 'Save up to 36% every month', d: 'And a free surprise gift' },
      { n: '4', t: 'Hassle-Free Test Booking', d: 'We call and book your slot' }
    ];

    const wrap = document.createElement('div');
    wrap.className = 'byb-how-it-works';
    wrap.innerHTML =
      '<div class="byb-hiw-title">How it works</div>' +
      '<div class="byb-hiw-steps">' +
      steps.map(s =>
        '<div class="byb-hiw-step"><span class="byb-hiw-num">' + s.n + '</span>' +
        '<div class="byb-hiw-text"><b>' + s.t + '</b><span>' + s.d + '</span></div></div>'
      ).join('') +
      '</div>';

    anchor.insertAdjacentElement('afterend', wrap);
  }

  ensureBloodTestPerk() {
    if (this.section.querySelector('.byb-blood-perk')) return;
    const anchor = this.section.querySelector('.byb-subheading-wrapper')
      || this.section.querySelector('.hometitle');
    if (!anchor) return;
    const div = document.createElement('div');
    div.className = 'byb-blood-perk';
    div.innerHTML =
      '<div class="byb-blood-head">' +
        '<span class="free-badge">FREE</span>' +
        '<span class="ttl">Iron + Zinc Blood Test — twice</span>' +
      '</div>' +
      '<p class="byb-blood-sub">Worth <s>₹2000</s> total — free with every subscription, <b style="text-decoration:underline;">on top of your discount</b>.</p>'  +
      '<div class="byb-blood-cards">' +
        '<div class="byb-blood-card"><div class="byb-blood-ic">💊</div><div class="byb-blood-txt"><span class="when">Day 0</span><span class="name">Iron + Zinc</span><span class="price"><s>₹1000</s><b>FREE</b></span></div></div>' +
        '<div class="byb-blood-card"><div class="byb-blood-ic">💊</div><div class="byb-blood-txt"><span class="when">Day 90</span><span class="name">Iron + Zinc</span><span class="price"><s>₹1000</s><b>FREE</b></span></div></div>' +
      '</div>';
    anchor.insertAdjacentElement('afterend', div);
  }

  renameMonthlyTotalLabel() {
    const monthlyLine = this.section.querySelector('.byb-total');
    if (!monthlyLine) return;
    const label = monthlyLine.querySelector('.byb-total-label');
    if (label) label.textContent = 'MONTHLY TOTAL';
  }

  ensureMonthlyLead() {
    if (this.monthlyLeadEl) return;
    const summaryLeft = this.section.querySelector('.byb-summary-left');
    if (!summaryLeft) return;

    const lead = document.createElement('div');
    lead.className = 'byb-monthly-lead';
    lead.innerHTML = '<span class="byb-lead-only">Only</span> ' +
      '<span class="byb-lead-amount">' + this.formatMoney(0) + '</span>' +
      '<span class="byb-lead-suffix">/month</span>';
    summaryLeft.insertAdjacentElement('afterbegin', lead);
    this.monthlyLeadEl = lead;
  }

  ensureTierHintLine() {
    if (this.tierHintEl) return;
    const monthlyLine = this.section.querySelector('.byb-total');
    if (!monthlyLine) return;
    const hint = document.createElement('div');
    hint.className = 'byb-tier-hint';
    monthlyLine.insertAdjacentElement('afterend', hint);
    this.tierHintEl = hint;
  }

  ensureSixMonthLine() {
    if (this.sixMonthTotalEl) return;
    const anchor = this.tierHintEl || this.section.querySelector('.byb-total');
    if (!anchor) return;

    const line = document.createElement('div');
    line.className = 'byb-total byb-total--six-month';

    const label = document.createElement('span');
    label.className = 'byb-total-label';
    label.textContent = `${this.months} MONTH TOTAL`;

    const value = document.createElement('span');
    value.className = 'byb-total-price byb-six-month-price';
    value.innerHTML = this.formatMoney(0);

    line.appendChild(label);
    line.appendChild(value);

    anchor.insertAdjacentElement('afterend', line);
    this.sixMonthTotalEl = value;
  }

  ensurePerDayLine() {
    if (this.perDayEl) return;
    const anchor = this.section.querySelector('.byb-total--six-month')
      || this.sixMonthTotalEl;
    if (!anchor) return;
    const line = document.createElement('div');
    line.className = 'byb-per-day';
    anchor.insertAdjacentElement('afterend', line);
    this.perDayEl = line;
  }

  /* ===== NEW: one-row stat strip (desktop footer) ===== */
  ensureStatStrip() {
    if (this.stripEls) return;
    const summaryLeft = this.section.querySelector('.byb-summary-left');
    if (!summaryLeft) return;

    const strip = document.createElement('div');
    strip.className = 'byb-stat-strip';
    strip.innerHTML =
      '<div class="byb-cell byb-cell--monthly">' +
        '<span class="byb-cell-label">MONTHLY</span>' +
        '<span class="byb-cell-price" data-strip-monthly>₹0</span>' +
      '</div>' +
      '<div class="byb-cell byb-cell--hero">' +
        '<span class="byb-cell-label">' + this.months + ' MONTHS</span>' +
        '<span class="byb-cell-price" data-strip-six>₹0</span>' +
        '<span class="byb-cell-perday byb-perday-flicker" data-strip-perday></span>' +
      '</div>' +
      '<div class="byb-cell byb-cell--save" data-strip-savecell>' +
        '<span class="byb-cell-unlock" data-strip-unlock></span>' +
        '<div class="byb-cell-savetop">' +
          '<span class="byb-cell-saveamt" data-strip-saveamt></span>' +
          '<span class="byb-cell-savepct" data-strip-savepct></span>' +
        '</div>' +
      '</div>';

    summaryLeft.appendChild(strip);

    this.stripEls = {
      strip,
      monthly: strip.querySelector('[data-strip-monthly]'),
      six: strip.querySelector('[data-strip-six]'),
      perday: strip.querySelector('[data-strip-perday]'),
      saveCell: strip.querySelector('[data-strip-savecell]'),
      unlock: strip.querySelector('[data-strip-unlock]'),
      saveAmt: strip.querySelector('[data-strip-saveamt]'),
      savePct: strip.querySelector('[data-strip-savepct]')
    };
  }

  updateStatStrip(subtotal, tierPercent, total, sixMonthSubtotal, sixMonthTotal, sixMonthSavings, perDay) {
    if (!this.stripEls) return;
    const S = this.stripEls;
    const hasDiscount = tierPercent > 0;

    // Empty box → hide strip, the tier hint does the talking
    S.strip.classList.toggle('is-empty', subtotal === 0);

    S.monthly.innerHTML = hasDiscount
      ? `<s>${this.formatMoney(subtotal)}</s>${this.formatMoney(total)}`
      : this.formatMoney(total);

    S.six.innerHTML = hasDiscount
      ? `<s>${this.formatMoney(sixMonthSubtotal)}</s>${this.formatMoney(sixMonthTotal)}`
      : this.formatMoney(sixMonthTotal);

    S.perday.innerHTML = subtotal > 0
      ? `less than ${this.formatMoney(perDay)}/day`
      : '';

    if (hasDiscount) {
      S.saveCell.style.display = '';
      S.unlock.textContent = tierPercent === 36
        ? '🪙 MAX SAVINGS UNLOCKED'
        : `✅ ${tierPercent}% OFF UNLOCKED`;
      S.saveAmt.textContent = this.formatMoney(sixMonthSavings);
      S.savePct.textContent = `${tierPercent}% OFF`;
    } else {
      S.saveCell.style.display = 'none';
    }
  }

  getTierPercent(subtotal) {
    if (subtotal >= 120000) return 36;
    if (subtotal >= 70000) return 30;
    return 0;
  }

  getTierCode(subtotal) {
    if (subtotal >= 120000) return 'BOX36';
    if (subtotal >= 70000) return 'BOX30';
    return '';
  }

  interceptAddToCart() {
    this.section.addEventListener('click', (e) => {
      const btn = e.target.closest('.add-single-product, .unified-atc-btn');
      if (btn && !btn.classList.contains('sold-out')) {
        const wrapper = btn.closest('.byb-product-wrapper');
        if (wrapper) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.handleProductAdd(wrapper, btn);
          return false;
        }
      }
    }, true);

    this.section.addEventListener('submit', (e) => {
      const form = e.target;
      const wrapper = form.closest('.byb-product-wrapper');
      if (wrapper) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const btn = form.querySelector('.add-single-product, .unified-atc-btn');
        if (btn) this.handleProductAdd(wrapper, btn);
        return false;
      }
    }, true);

    const forms = this.section.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      const wrapper = form.closest('.byb-product-wrapper');
      if (wrapper) {
        form.addEventListener('submit', (e) => { e.preventDefault(); return false; });
      }
    });
  }

  bindEvents() {
    this.section.addEventListener('click', (e) => {
      const variantBtn = e.target.closest('.unified-variant-btn');
      if (variantBtn && !variantBtn.disabled) {
        setTimeout(() => {
          const wrapper = variantBtn.closest('.byb-product-wrapper');
          if (wrapper) this.updateWrapperVariantData(wrapper);
        }, 100);
      }
    });

    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener('click', () => {
        const subtotal = this.getSubtotal();
        if (subtotal < this.minSubtotal) return;
        if (this.isMobile()) {
          this.openReviewModal();
        } else {
          this.handleCheckout();
        }
      });
    }

    window.addEventListener('scroll', () => this.handleScroll());
  }

  updateWrapperVariantData(wrapper) {
    const variantSelect = wrapper.querySelector('.variant-option-js');
    if (variantSelect) {
      const selectedOption = variantSelect.querySelector('option:checked');
      if (selectedOption) {
        const variantId = selectedOption.dataset.id;
        const price = selectedOption.dataset.price;

        const addBtn = wrapper.querySelector('.unified-atc-btn, .add-single-product');
        if (addBtn && variantId) addBtn.dataset.variantId = variantId;

        if (variantId && price) {
          wrapper.dataset.currentVariantId = variantId;
          wrapper.dataset.currentVariantPrice = this.extractPrice(price);
        }
      }
    }
  }

  extractPrice(priceString) {
    const match = String(priceString).match(/[\d,]+\.?\d*/);
    if (match) {
      const numStr = match[0].replace(/,/g, '');
      return Math.round(parseFloat(numStr) * 100);
    }
    return 0;
  }

  rememberOriginalButtonLabel(wrapper) {
    const btn = wrapper.querySelector('.unified-atc-btn, .add-single-product');
    if (btn && btn.dataset.originalLabel === undefined) {
      btn.dataset.originalLabel = 'Add to My Box';
    }
    return btn;
  }

  setCardButtonState(productId) {
    const wrapper = this.section.querySelector(`.byb-product-wrapper[data-product-id="${productId}"]`);
    if (!wrapper) return;
    const btn = this.rememberOriginalButtonLabel(wrapper);
    if (!btn) return;

    const inBox = this.getQtyForProduct(productId) > 0;
    const labelTarget = btn.querySelector('.atc-text, .btn-text') || btn;
    if (inBox) {
      labelTarget.textContent = 'ADD MORE';
      btn.classList.add('byb-added');
      wrapper.classList.add('selected');
    } else {
      labelTarget.textContent = btn.dataset.originalLabel || 'Add to My Box';
      btn.classList.remove('byb-added');
      wrapper.classList.remove('selected');
    }
  }

  refreshAllCardButtons() {
    const wrappers = this.section.querySelectorAll('.byb-product-wrapper[data-product-id]');
    wrappers.forEach(w => this.setCardButtonState(w.dataset.productId));
  }

  handleProductAdd(wrapper, button) {
    const productId = wrapper.dataset.productId;
    const productTitle = wrapper.dataset.productTitle;
    this.rememberOriginalButtonLabel(wrapper);

    let variantId = button.dataset.variantId || wrapper.dataset.currentVariantId;
    if (!variantId) {
      const variantSelect = wrapper.querySelector('.variant-option-js');
      if (variantSelect) {
        const selectedOption = variantSelect.querySelector('option:checked, option[selected]');
        if (selectedOption) variantId = selectedOption.dataset.id;
      }
    }

    const priceEl = wrapper.querySelector('.unified-current-price');
    let productPrice = 0;
    if (priceEl) productPrice = this.extractPrice(priceEl.textContent);

    const existing = this.selectedProducts.find(p => p.variantId === variantId && variantId);
    if (existing) {
      existing.qty += 1;
      existing.productPrice = productPrice;
    } else {
      this.selectedProducts.push({ productId, variantId, productTitle, productPrice, qty: 1 });
    }

    this.updateUI();
  }

  initStickyFooter() {
    if (this.stickyFooter) this.stickyFooter.classList.remove('hidden');
  }

  handleScroll() {
    if (!this.stickyFooter) return;
    const sectionRect = this.section.getBoundingClientRect();
    const sectionBottom = sectionRect.bottom;
    const windowHeight = window.innerHeight;
    if (sectionBottom < 0 || sectionRect.top > windowHeight) {
      this.stickyFooter.classList.add('hidden');
    } else {
      this.stickyFooter.classList.remove('hidden');
    }
  }

  updateUI() {
    const units = [];
    this.selectedProducts.forEach((p) => {
      for (let q = 0; q < p.qty; q++) units.push(p);
    });

    const slotsContainer = this.section.querySelector('.byb-slots');
    if (slotsContainer) {
      slotsContainer.innerHTML = '';

      units.forEach((product, i) => {
        const slot = document.createElement('div');
        slot.className = 'byb-slot filled';

        const imgWrapper = document.createElement('div');
        imgWrapper.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border-radius:8px;overflow:hidden;';

        const img = document.createElement('img');
        const wrapper = this.section.querySelector(`.byb-product-wrapper[data-product-id="${product.productId}"]`);
        if (wrapper) {
          const productImg = wrapper.querySelector('img');
          if (productImg) {
            img.src = productImg.src;
            img.alt = product.productTitle;
            img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
          }
        }
        imgWrapper.appendChild(img);
        slot.appendChild(imgWrapper);

        const removeBtn = document.createElement('div');
        removeBtn.className = 'slot-remove';
        removeBtn.innerHTML = '×';
        removeBtn.setAttribute('data-variant-id', product.variantId);
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.removeUnit(product.variantId);
        });
        slot.appendChild(removeBtn);

        slotsContainer.appendChild(slot);

        if (i < units.length - 1) {
          const separator = document.createElement('div');
          separator.className = 'byb-slot-separator';
          separator.textContent = '+';
          slotsContainer.appendChild(separator);
        }
      });
    }

    this.refreshAllCardButtons();

    const subtotal = this.getSubtotal();
    const tierPercent = this.getTierPercent(subtotal);
    const discount = (subtotal * tierPercent) / 100;
    const total = subtotal - discount; // monthly net

    const sixMonthSubtotal = subtotal * this.months;
    const sixMonthTotal = total * this.months;
    const sixMonthSavings = discount * this.months;
    const perDay = total / this.daysPerMonth;

    if (this.monthlyLeadEl) {
      this.monthlyLeadEl.querySelector('.byb-lead-amount').innerHTML = this.formatMoney(total);
    }

    if (this.totalPriceEl) {
      this.totalPriceEl.innerHTML = discount > 0
        ? `<span class="byb-mrp-strike">${this.formatMoney(subtotal)}</span> <span class="byb-now-price">${this.formatMoney(total)}</span>`
        : this.formatMoney(total);
    }

    if (this.tierHintEl) {
      // At max tier the strip's gold cell already says it — keep hint for progress states only
      this.tierHintEl.innerHTML = tierPercent === 36 ? '' : this.buildTierHint(subtotal, tierPercent);
      this.tierHintEl.style.display = tierPercent === 36 ? 'none' : '';
    }

    if (this.sixMonthTotalEl) {
      this.sixMonthTotalEl.innerHTML = discount > 0
        ? `<span class="byb-mrp-strike">${this.formatMoney(sixMonthSubtotal)}</span> <span class="byb-now-price">${this.formatMoney(sixMonthTotal)}</span>`
        : this.formatMoney(sixMonthTotal);
    }

    if (this.perDayEl) {
      this.perDayEl.innerHTML = subtotal > 0
        ? `Less than <b>${this.formatMoney(perDay)}/day</b>`
        : '';
    }

    if (this.savingsContainer && discount > 0) {
      this.savingsEl.innerHTML = `${this.formatMoney(sixMonthSavings)} <span class="byb-save-pct">(${tierPercent}% OFF)</span>`;
      this.savingsContainer.style.display = 'flex';
    } else if (this.savingsContainer) {
      this.savingsContainer.style.display = 'none';
    }

    // NEW: feed the stat strip
    this.updateStatStrip(subtotal, tierPercent, total, sixMonthSubtotal, sixMonthTotal, sixMonthSavings, perDay);

    const incompleteText = this.checkoutBtn.querySelector('.incomplete-text');
    const completeText = this.checkoutBtn.querySelector('.complete-text');
    const amountRequirementMet = subtotal >= this.minSubtotal;

    if (amountRequirementMet) {
      this.checkoutBtn.disabled = false;
      incompleteText.style.display = 'none';
      completeText.style.display = '';
      completeText.textContent = tierPercent > 0 ? `ORDER NOW — SAVE ${tierPercent}%` : 'ORDER NOW';
    } else {
      this.checkoutBtn.disabled = true;
      incompleteText.textContent = `ADD ${this.formatMoney(this.minSubtotal)} OR MORE`;
      incompleteText.style.display = '';
      completeText.style.display = 'none';
    }

    if (this.modalOpen) {
      this.populateReviewModal(subtotal, tierPercent, total, sixMonthSubtotal, sixMonthTotal, sixMonthSavings, perDay);
    }
  }

  buildTierHint(subtotal, tierPercent) {
    const t1 = 70000, t2 = 120000;
    if (subtotal === 0) {
      return `<span class="byb-hint-line">🎁 Spend <b>₹700</b>/month for <b>30% OFF</b> — or <b>₹1200</b>+ for <b>36% OFF</b>!</span>`;
    }
    if (tierPercent === 0) {
      return `<span class="byb-hint-line">🔓 Add <b>${this.formatMoney(t1 - subtotal)}</b> more to unlock <b>30% OFF</b> (then <b>${this.formatMoney(t2 - subtotal)}</b> more for <b>36% OFF</b>)</span>`;
    }
    if (tierPercent === 30) {
      return `<span class="byb-hint-line byb-hint-line--active">✅ You unlocked <b>30% OFF</b>! Add <b>${this.formatMoney(t2 - subtotal)}</b> more to upgrade to <b>36% OFF</b></span>`;
    }
    return `<span class="byb-hint-line byb-hint-line--active">🏆 Max savings unlocked — you're getting <b>36% OFF</b>!</span>`;
  }

  /* ---------- Mobile review modal ---------- */
  buildReviewModal() {
    if (this.reviewModal) return;

    const overlay = document.createElement('div');
    overlay.className = 'byb-modal-overlay';
    overlay.innerHTML =
      '<div class="byb-modal" role="dialog" aria-modal="true">' +
        '<button class="byb-modal-close" aria-label="Close">×</button>' +
        '<div class="byb-modal-title">Review your subscription</div>' +
        '<div class="byb-modal-badge"></div>' +
        '<div class="byb-modal-rows"></div>' +
        '<button class="byb-modal-proceed">Proceed to Checkout</button>' +
        '<button class="byb-modal-keep">Keep adding products</button>' +
      '</div>';

    document.body.appendChild(overlay);
    this.reviewModal = overlay;

    overlay.querySelector('.byb-modal-close').addEventListener('click', () => this.closeReviewModal());
    overlay.querySelector('.byb-modal-keep').addEventListener('click', () => this.closeReviewModal());
    overlay.querySelector('.byb-modal-proceed').addEventListener('click', () => {
      this.closeReviewModal();
      this.handleCheckout();
    });
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) this.closeReviewModal();
    });
  }

  populateReviewModal(subtotal, tierPercent, total, sixMonthSubtotal, sixMonthTotal, sixMonthSavings, perDay) {
    if (!this.reviewModal) return;
    const badge = this.reviewModal.querySelector('.byb-modal-badge');
    const rows = this.reviewModal.querySelector('.byb-modal-rows');
    const t2 = 120000;

    if (tierPercent > 0) {
      badge.className = 'byb-modal-badge is-active';
      badge.innerHTML = `✅ Min ₹700 reached — <b>${tierPercent}% OFF unlocked!</b>`;
    } else {
      badge.className = 'byb-modal-badge';
      badge.innerHTML = `Add <b>${this.formatMoney(this.minSubtotal - subtotal)}</b> more to unlock 30% OFF`;
    }

    let html = '';
    html += `<div class="byb-mrow byb-mrow--lead"><span>Per month</span><b>Only ${this.formatMoney(total)}/month</b></div>`;
    if (tierPercent > 0) {
      html += `<div class="byb-mrow"><span>Monthly total</span><span><s>${this.formatMoney(subtotal)}</s> ${this.formatMoney(total)}</span></div>`;
      html += `<div class="byb-mrow"><span>${this.months}-month total</span><span><s>${this.formatMoney(sixMonthSubtotal)}</s> ${this.formatMoney(sixMonthTotal)}</span></div>`;
      html += `<div class="byb-mrow byb-mrow--day"><span>Cost per day</span><b class="byb-perday-flicker">Less than ${this.formatMoney(perDay)}/day</b></div>`;
      html += `<div class="byb-mrow byb-mrow--save"><span>Total savings</span><b>${this.formatMoney(sixMonthSavings)} (${tierPercent}% OFF)</b></div>`;
    } else {
      html += `<div class="byb-mrow"><span>Monthly total</span><b>${this.formatMoney(total)}</b></div>`;
      html += `<div class="byb-mrow"><span>${this.months}-month total</span><b>${this.formatMoney(sixMonthTotal)}</b></div>`;
    }
    if (tierPercent === 30 && subtotal < t2) {
      html += `<div class="byb-mrow byb-mrow--upsell">🎁 Add <b>${this.formatMoney(t2 - subtotal)}</b> more to upgrade to <b> FLAT 36% off</b></div>`;
    }
    rows.innerHTML = html;

    const proceed = this.reviewModal.querySelector('.byb-modal-proceed');
    proceed.disabled = subtotal < this.minSubtotal;
    proceed.textContent = tierPercent > 0 ? `Proceed to Checkout — Save ${tierPercent}%` : 'Proceed to Checkout';
  }

  openReviewModal() {
    if (!this.reviewModal) this.buildReviewModal();
    this.modalOpen = true;
    const subtotal = this.getSubtotal();
    const tierPercent = this.getTierPercent(subtotal);
    const discount = (subtotal * tierPercent) / 100;
    const total = subtotal - discount;
    this.populateReviewModal(
      subtotal, tierPercent, total,
      subtotal * this.months, total * this.months,
      discount * this.months, total / this.daysPerMonth
    );
    this.reviewModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  closeReviewModal() {
    this.modalOpen = false;
    if (this.reviewModal) this.reviewModal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  removeUnit(variantId) {
    const idx = this.selectedProducts.findIndex(p => p.variantId === variantId);
    if (idx > -1) {
      this.selectedProducts[idx].qty -= 1;
      if (this.selectedProducts[idx].qty <= 0) {
        this.selectedProducts.splice(idx, 1);
      }
      this.updateUI();
      this.showNotification('Item removed', 'info');
    }
  }

  handleCheckout() {
    const subtotal = this.getSubtotal();

    if (subtotal < this.minSubtotal) {
      this.showNotification(`Minimum amount ${this.formatMoney(this.minSubtotal)} required`, 'error');
      return;
    }

    const missing = this.selectedProducts.some(p => !p.variantId);
    if (missing) {
      this.showNotification('Please pick a size for each product before checkout.', 'error');
      return;
    }

    this.checkoutBtn.classList.add('loading');
    this.checkoutBtn.disabled = true;

    const tierCode = this.getTierCode(subtotal);
    const items = this.selectedProducts
      .map(p => `${Number(p.variantId)}:${p.qty * this.checkoutMultiplier}`)
      .join(',');

    let url = `/cart/${items}?checkout`;
    if (tierCode) url += `&discount=${encodeURIComponent(tierCode)}`;

    window.location.href = url;
  }

  formatMoney(cents) {
    return `₹${(cents / 100).toFixed(0)}`;
  }

  showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `byb-notification byb-notification--${type}`;
    notification.textContent = message;

    Object.assign(notification.style, {
      position: 'fixed', top: '20px', right: '20px', padding: '16px 24px',
      background: type === 'success' ? '#4caf50' : type === 'error' ? '#f44366' : '#ff9800',
      color: 'white', borderRadius: '6px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      zIndex: '10000', fontSize: '14px', fontWeight: '600', maxWidth: '300px',
      animation: 'slideInRight 0.3s ease'
    });

    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideInRight { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
      @keyframes slideOutRight { from { transform: translateX(0); opacity: 1; } to { transform: translateX(100%); opacity: 0; } }
    `;
    document.head.appendChild(style);
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => { notification.remove(); style.remove(); }, 300);
    }, 3000);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => { new BuildYourBox(); });
} else {
  new BuildYourBox();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.build-your-box-section')) {
    new BuildYourBox();
  }
});

/* Single style block: orange button + pills + blood perk + how-it-works + slim mobile bar + review modal + stat strip */
(function(){
  if (document.getElementById('byb-responsive-styles')) return;
  var s = document.createElement('style');
  s.id = 'byb-responsive-styles';
  s.textContent = [
    /* Orange selected button (beats theme green) */
    '.build-your-box-section .byb-product-wrapper.selected .unified-atc-btn:not(.sold-out),',
    '.build-your-box-section .byb-product-wrapper.selected .unified-atc-btn.byb-added:not(.sold-out),',
    '.build-your-box-section .byb-product-wrapper.selected .add-single-product:not(.sold-out){background:#BF570A!important;background-color:#BF570A!important;border-color:#BF570A!important;color:#fff!important;}',
    '.build-your-box-section .byb-product-wrapper.selected .unified-atc-btn:not(.sold-out):hover{background:#A84D09!important;background-color:#A84D09!important;}',

    /* Tier pills — unified green selector */
    '.byb-tier-pills{display:flex;justify-content:center;align-items:stretch;background:#fff;border:1px solid #cfe6d8;border-radius:16px;padding:6px;max-width:520px;margin:14px auto 0;box-shadow:0 4px 18px rgba(17,75,60,.06);}',
    '.byb-tier-pill{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;padding:12px 14px;border-radius:11px;font-size:13px;font-weight:600;color:#5f6f68;position:relative;transition:.18s ease;}',
    '.byb-tier-pill .pct{font-size:20px;font-weight:800;color:#114b3c;line-height:1.1;}',
    '.byb-tier-pill--b{background:#114b3c;color:#cfe9db;box-shadow:0 6px 14px rgba(17,75,60,.22);}',
    '.byb-tier-pill--b .pct{color:#fff;}',
    '.byb-tier-pill--b::before{content:"Best value";position:absolute;top:-9px;right:14px;background:#1f8a5b;color:#fff;font-size:9.5px;font-weight:700;letter-spacing:.4px;padding:2px 7px;border-radius:20px;text-transform:uppercase;}',

    /* How it works */
    '.byb-how-it-works{max-width:1000px;margin:8px auto 20px;padding:0 16px;}',
    '.byb-hiw-title{font-weight:700;font-size:16px;text-align:center;margin-bottom:12px;color:#21685A;}',
    '.byb-hiw-steps{display:flex;gap:12px;flex-wrap:wrap;justify-content:center;}',
    '.byb-hiw-step{display:flex;align-items:center;gap:10px;background:#f6fbf9;border:1px solid #d6ebe4;border-radius:10px;padding:10px 14px;flex:1 1 200px;max-width:240px;}',
    '.byb-hiw-num{flex:0 0 28px;width:28px;height:28px;border-radius:50%;background:#21685A;color:#fff;font-weight:700;display:flex;align-items:center;justify-content:center;font-size:14px;}',
    '.byb-hiw-text{display:flex;flex-direction:column;line-height:1.25;}',
    '.byb-hiw-text b{font-size:13px;}.byb-hiw-text span{font-size:12px;color:#5a6b66;}',

    /* Blood test perk — tied to discount story */
    '.byb-blood-perk{max-width:1000px;margin:6px auto 22px;padding:22px 22px 18px;background:#fbf4ec;border:1px solid #f4d9c2;border-radius:18px;}',
    '.byb-blood-head{display:flex;align-items:center;justify-content:center;gap:10px;flex-wrap:wrap;text-align:center;margin-bottom:6px;}',
    '.byb-blood-head .free-badge{background:#114b3c;color:#fff;font-size:11px;font-weight:800;padding:5px 11px;border-radius:30px;letter-spacing:.6px;text-transform:uppercase;}',
    '.byb-blood-head .ttl{font-size:17px;font-weight:800;color:#114b3c;}',
    '.byb-blood-sub{text-align:center;font-size:13.5px;color:#5f6f68;margin:0 0 16px;}',
    '.byb-blood-sub s{color:#c0392b;font-weight:600;}',
    '.byb-blood-sub b{color:#1f8a5b;}',
    '.byb-blood-cards{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;}',
    '.byb-blood-card{flex:1 1 280px;max-width:340px;display:flex;align-items:center;gap:14px;background:#fff;border:1px solid #f0e2d4;border-radius:14px;padding:14px 16px;}',
    '.byb-blood-ic{flex:0 0 42px;width:42px;height:42px;border-radius:50%;background:#fde7ee;display:flex;align-items:center;justify-content:center;font-size:20px;}',
    '.byb-blood-txt{display:flex;flex-direction:column;line-height:1.35;}',
    '.byb-blood-txt .when{font-size:11px;font-weight:700;color:#c98a2b;text-transform:uppercase;letter-spacing:.5px;}',
    '.byb-blood-txt .name{font-weight:700;font-size:14.5px;color:#22302b;margin:1px 0 2px;}',
    '.byb-blood-txt .price{font-size:12.5px;color:#5f6f68;}',
    '.byb-blood-txt .price s{margin-right:6px;}',
    '.byb-blood-txt .price b{color:#1f8a5b;font-weight:800;}',

    /* Monthly-first pricing */
    '.byb-monthly-lead{display:flex;align-items:baseline;justify-content:flex-end;gap:4px;margin-bottom:4px;}',
    '.byb-lead-only{font-size:13px;color:#5a6b66;}',
    '.byb-lead-amount{font-size:26px;font-weight:800;color:#BF570A;}',
    '.byb-lead-suffix{font-size:14px;font-weight:600;color:#5a6b66;}',
    '.byb-per-day{font-size:12px;color:#237804;text-align:right;margin-top:2px;}',
    '.byb-mrp-strike{text-decoration:line-through;opacity:.55;margin-right:6px;font-weight:400;}',
    '.byb-now-price,.byb-save-pct{font-weight:700;}',
    '.byb-tier-hint{margin-top:6px;font-size:13px;line-height:1.35;text-align:right;}',
    '.byb-hint-line{display:inline-block;background:#fff7e6;border:1px solid #ffd591;color:#ad6800;padding:5px 9px;border-radius:8px;}',
    '.byb-hint-line--active{background:#f6ffed;border-color:#b7eb8f;color:#237804;}',

    /* ===== NEW: One-row stat strip (Monthly · 6 Months · You Save) ===== */
    '.byb-stat-strip{display:none;align-items:stretch;background:#fff;border:1px solid #e2dac8;border-radius:12px;overflow:hidden;box-shadow:0 1px 4px rgba(0,0,0,.05);width:max-content;max-width:100%;}',
    '.byb-stat-strip.is-empty{display:none!important;}',
    '.byb-cell{padding:8px 16px;display:flex;flex-direction:column;justify-content:center;gap:2px;position:relative;}',
    '.byb-cell+.byb-cell::before{content:"";position:absolute;left:0;top:18%;height:64%;width:1px;background:#ece5d4;}',
    '.byb-cell-label{font-size:9.5px;font-weight:700;letter-spacing:.12em;color:#7d8a83;}',
    '.byb-cell-price{font-size:17px;font-weight:800;color:#22302a;line-height:1.15;white-space:nowrap;}',
    '.byb-cell-price s{font-size:11.5px;color:#9aa6a0;font-weight:500;margin-right:6px;}',
    '.byb-cell--hero .byb-cell-price{font-size:20px;}',
    '.byb-cell-perday{font-size:11px;font-weight:700;color:#1d7a4f;white-space:nowrap;}',
    '.byb-perday-flicker{animation:bybFlicker 2.2s ease-in-out infinite;}',
    '@keyframes bybFlicker{0%,100%{opacity:1;}50%{opacity:.35;}}',
    '@media (prefers-reduced-motion:reduce){.byb-perday-flicker{animation:none;}}',
    '.byb-cell--save{background:linear-gradient(135deg,#fdf3df,#fbe9c6);border-left:1px dashed #e3c98f;align-items:flex-start;padding-right:18px;}',
    '.byb-cell--save::before{display:none;}',
    '.byb-cell-unlock{font-size:9.5px;font-weight:700;color:#9a7416;letter-spacing:.06em;white-space:nowrap;}',
    '.byb-cell-savetop{display:flex;align-items:center;gap:7px;}',
    '.byb-cell-saveamt{font-size:17px;font-weight:800;color:#15402e;line-height:1.1;white-space:nowrap;}',
    '.byb-cell-savepct{background:#1d5c42;color:#fff;font-size:10px;font-weight:800;padding:2px 7px;border-radius:12px;letter-spacing:.04em;white-space:nowrap;}',

    /* ===== Compact desktop footer: strip replaces stacked lines ===== */
    '@media (min-width:750px){',
      '.byb-sticky-footer{padding:10px 0!important;}',
      '.byb-footer-content{align-items:center!important;gap:16px!important;}',
      /* slots strip: cap width + scroll instead of growing the row off-screen */
      '.byb-selection-tracker{flex:1 1 0!important;min-width:0!important;overflow-x:auto!important;overflow-y:hidden!important;}',
      '.byb-slots{flex-wrap:nowrap!important;}',
      /* summary + button never shrink or get pushed away */
      '.byb-summary{flex:0 0 auto!important;align-items:center!important;}',
      '.byb-checkout-btn{flex:0 0 auto!important;}',
      '.byb-summary-left{display:flex!important;flex-direction:column!important;align-items:flex-end!important;gap:4px!important;}',
      /* show the strip, hide the old stacked lines */
      '.byb-stat-strip{display:flex!important;}',
      '.byb-summary-left .byb-monthly-lead,',
      '.byb-summary-left .byb-total,',
      '.byb-summary-left .byb-total--six-month,',
      '.byb-summary-left .byb-per-day,',
      '.byb-summary-left .byb-savings{display:none!important;}',
      /* tier hint (progress nudge) sits under the strip, compact */
      '.byb-summary-left .byb-tier-hint{margin-top:0!important;font-size:11.5px!important;line-height:1.3!important;order:2;}',
      '.byb-summary-left .byb-tier-hint .byb-hint-line{padding:3px 8px!important;}',
      '.byb-summary-left .byb-stat-strip{order:1;}',
    '}',

    /* ===== MOBILE ===== */
    '@media (max-width:749px){',
      '.byb-stat-strip{display:none!important;}',
      '.byb-tier-pills{margin-left:12px;margin-right:12px;}',
      '.byb-tier-pill .pct{font-size:18px;}',
      '.byb-blood-perk{padding:14px;}',
      '.byb-blood-head{margin-bottom:4px;gap:6px;}',
      '.byb-blood-head .ttl{font-size:14px;}',
      '.byb-blood-sub{font-size:12px;margin-bottom:10px;}',
      '.byb-blood-cards{flex-direction:row;align-items:stretch;gap:8px;}',
      '.byb-blood-card{flex:1 1 0;min-width:0;max-width:none;background:#fff;border:1px solid #f0e2d4;border-radius:12px;padding:10px;gap:8px;border-bottom:1px solid #f0e2d4;}',
      '.byb-blood-txt{min-width:0;}',
      '.byb-blood-ic{flex:0 0 30px;width:30px;height:30px;font-size:15px;background:#fde7ee;}',
      '.byb-blood-txt .when{font-size:10px;}',
      '.byb-blood-txt .name{font-size:13px;}',
      '.byb-blood-txt .price{font-size:11px;}',
      '.byb-blood-card:last-child{border-bottom:none;}',
      '.byb-blood-ic{flex:0 0 32px;width:32px;height:32px;font-size:16px;background:#fbe4d8;}',
      '.byb-how-it-works .byb-hiw-steps{flex-direction:column;}',
      '.byb-how-it-works .byb-hiw-step{max-width:none;flex:1 1 auto;}',
      '.byb-sticky-footer{padding:8px 0!important;}',
      '.byb-footer-content{flex-direction:row!important;align-items:center!important;gap:10px!important;padding:0 12px!important;}',
      '.byb-selection-tracker{display:none!important;}',
      '.byb-summary{flex:1!important;width:auto!important;flex-direction:row!important;align-items:center!important;gap:10px!important;justify-content:flex-start!important;}',
      '.byb-summary-left{flex:1!important;width:auto!important;text-align:left!important;align-items:flex-start!important;}',
      '.byb-summary-left .byb-total,',
      '.byb-summary-left .byb-total--six-month,',
      '.byb-summary-left .byb-savings,',
      '.byb-summary-left .byb-per-day,',
      '.byb-summary-left .byb-tier-hint{display:none!important;}',
      '.byb-monthly-lead{margin:0!important;justify-content:flex-start!important;}',
      '.byb-lead-amount{font-size:20px!important;}',
      '.byb-lead-only,.byb-lead-suffix{font-size:12px!important;}',
      '.byb-checkout-btn{flex:0 0 auto!important;width:auto!important;min-width:0!important;padding:12px 18px!important;font-size:13px!important;letter-spacing:.5px!important;}',
    '}',

    /* ===== Review modal ===== */
    '.byb-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:11000;display:none;align-items:flex-end;justify-content:center;}',
    '.byb-modal-overlay.is-open{display:flex;}',
    '.byb-modal{background:#fff;width:100%;max-width:460px;border-radius:16px 16px 0 0;padding:20px 18px 24px;position:relative;box-shadow:0 -10px 40px rgba(0,0,0,.25);animation:bybSlideUp .25s ease;}',
    '@keyframes bybSlideUp{from{transform:translateY(100%);}to{transform:translateY(0);}}',
    '.byb-modal-close{position:absolute;top:10px;right:12px;width:32px;height:32px;border:none;background:#f2f2f2;border-radius:50%;font-size:20px;line-height:1;color:#555;cursor:pointer;}',
    '.byb-modal-title{font-size:18px;font-weight:800;color:#21685A;margin:2px 0 12px;}',
    '.byb-modal-badge{font-size:13px;padding:8px 12px;border-radius:10px;background:#fff7e6;border:1px solid #ffd591;color:#ad6800;margin-bottom:14px;}',
    '.byb-modal-badge.is-active{background:#f6ffed;border-color:#b7eb8f;color:#237804;}',
    '.byb-modal-rows{display:flex;flex-direction:column;gap:2px;margin-bottom:16px;}',
    '.byb-mrow{display:flex;align-items:center;justify-content:space-between;padding:9px 2px;border-bottom:1px solid #f0f0f0;font-size:14px;color:#444;}',
    '.byb-mrow s{opacity:.5;margin-right:5px;font-weight:400;}',
    '.byb-mrow--lead{font-size:16px;}.byb-mrow--lead b{color:#BF570A;}',
    '.byb-mrow--day b{color:#237804;}',
    '.byb-mrow--save{border-bottom:none;}.byb-mrow--save b{color:#21685A;}',
    '.byb-mrow--upsell{justify-content:center;background:#fff7e6;border:1px solid #ffd591;color:#ad6800;border-radius:8px;padding:9px 10px;margin-top:8px;font-size:13px;border-bottom:none;}',
    '.byb-modal-proceed{width:100%;padding:15px;border:none;border-radius:10px;background:#BF570A;color:#fff;font-size:15px;font-weight:800;text-transform:uppercase;letter-spacing:.5px;cursor:pointer;}',
    '.byb-modal-proceed:disabled{background:#e0e0e0;color:#999;cursor:not-allowed;}',
    '.byb-modal-proceed:not(:disabled):active{transform:translateY(1px);}',
    '.byb-modal-keep{width:100%;margin-top:10px;padding:10px;border:none;background:transparent;color:#888;font-size:13px;font-weight:600;cursor:pointer;text-decoration:underline;}'
  ].join('');
  document.head.appendChild(s);
})();